<template>
  <a-modal
    :title="title"
    style="top: 20px;"
    :width="1000"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
  >
  <a-card :bordered="false" :bodyStyle="{ padding: 0}">

    <s-table
      size="default"
      ref="table"
      rowKey="id"
      :pageSize=20
      :columns="columns"
      :data="loadData"
      bordered
    >
      <span slot="action" slot-scope="text, record">
        <a-popconfirm title="确定要删除此收款记录吗?" @confirm="confirm(record)" okText="确定" cancelText="取消">
          <a href="#">删除</a>
        </a-popconfirm>
      </span>
    </s-table>
  </a-card>
  </a-modal>
</template>
<script>
import STable from '@/components/table/'
import { getProceedsItemsList, deleteProceedsItem } from '@/api/money'
import { CODE_FAIL } from '@/store/mutation-types'
export default {
  name: 'ProceedsItemsList',
  props: {
    mpiId: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  components: {
    STable
  },
  data () {
    return {
      // 表头
      columns: [
        {
          title: '收款时间',
          dataIndex: 'date',
          className: 'text-center'
        },
        {
          title: '客户',
          dataIndex: 'customer.name',
          className: 'text-center'
        },
        {
          title: '收款金额',
          dataIndex: 'money',
          className: 'text-right'
        },
        {
          title: '备注',
          dataIndex: 'note',
          className: 'text-center'
        },
        {
          title: '操作',
          width: '150px',
          dataIndex: 'action',
          className: 'text-center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getProceedsItemsList(Object.assign(parameter, { mpiId: this.mpiId }))
          .then(res => {
            return res.result
          })
      }
    }
  },
  created () {

  },
  methods: {
    handleOk () {
      this.$emit('handleOk')
    },
    handleCancel () {
      this.$emit('handleCancel')
    },
    confirm (record) {
      deleteProceedsItem({ id: record.id }).then(res => {
        if (res.status !== CODE_FAIL) {
          this.$message.success('删除成功')
        } else {
          this.$message.error(res.message)
        }
      }).finally(() => {
        this.$refs.table.refresh(true)
      })
    }
  },
  watch: {
  }
}
</script>

<style>

  th.text-right, td.text-right {
    text-align: right !important;
  }
  th.text-center, td.text-center {
    text-align: center !important;
  }
</style>